import React, { FC } from 'react';
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import { clss } from '../../../../utils/helpers/styleHelpers';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, ContentState } from 'draft-js';
import { useAppSelector } from '../../../../store/hooks';
import { selectDirection } from '../../../../store/selectors/appSelectors';

import styles from '../../form.module.scss';

type TextAreaWysiwygFieldPropTypes = {
    name: string;
    label: string;
    errorMessage: string;
    hintText?: string;
    register: any;
    orderIndex: number;
    defaultValue: any;
    style: any;
    props: any;
    onChange: (value: any) => void;
    extraContent: any;
}

const TextAreaWysiwygField: FC<TextAreaWysiwygFieldPropTypes> = (props) => {
    const {
        name,
        label,
        errorMessage,
        hintText,
        register,
        orderIndex,
        defaultValue,
        style,
        props: outerProps,
        onChange,
        extraContent,
    } = props;
    const direction = useAppSelector(selectDirection);

    const blocksFromHtml = htmlToDraft('<p></p>');
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);

    return (
        <div key={name} style={{ order: orderIndex, ...style }}>
            <Label label={label} name={name} hintText={hintText} >
                <Editor
                    defaultContentState={contentState}
                    defaultEditorState={editorState}
                    wrapperClassName={styles.textareaWysiwygField}
                    editorClassName={clss([styles.textareaField, styles.field, errorMessage ? styles.errorField : ''])}
                    // onChange={(value: any) => onChange(value)}
                    onContentStateChange={(value: any) => onChange(value)}
                    // {...register(name as `${string}`)}
                    {...outerProps}
                    dir={direction}
                />
            </Label>
            <ErrorText text={errorMessage} />
            {!!extraContent && extraContent()}
        </div>
    );
};

export default TextAreaWysiwygField;